<div class="header" [ngClass]="{'collapsed': collapsed, 'expanded': !collapsed}" (click)="toggle()">
  <div><ng-content select="[header]"></ng-content></div>
  <i class="fa" [ngClass]="{'fa-chevron-down' : collapsed, 'fa-chevron-up' : !collapsed}"></i>
</div>
<div class="body">
  <ng-content></ng-content>
</div>
